<template>
  <ModalConfirmAlert
    :id="'modalNewMailsAlert'"
    :message="msgAlert"
    @yes="redirectNewMails()" />
</template>

<script>
import { mapState, mapActions } from "vuex";
import ModalConfirmAlert from "/src/components/modals/ModalConfirmAlert.vue";
import { mixinModal } from "/src/mixins";
import { createNewMailsTask } from "/src/service/new-mail.service.js";

export default {
  name: "NewMailsCreate",
  components: {
    ModalConfirmAlert,
  },
  mixins: [mixinModal],
  data() {
    return {
      dataCreateMails: false,
      msgAlert: "",
      msgSuccsess: "メール送信処理を受付けました。",
      msgFail: "サーバにはエラーが発生しました。",
      interval: null,
    };
  },
  computed: {
    ...mapState("newMails", ["actionCreateMails"]),
  },
  watch: {
    actionCreateMails() {
      this.showModalNewMails();
    },
  },
  created() {
    this.getDataCreateMails();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    ...mapActions("alertMessage", ["showAlert"]),
    ...mapActions("newMails", ["setStatusMails", "setActionMails"]),
    getDataCreateMails() {
      let isCreateMails = localStorage.getItem("newMailsStatus");
      if (isCreateMails == "true") {
        this.dataCreateMails = true;
      } else {
        this.dataCreateMails = false;
      }
      this.setStatusMails(this.dataCreateMails);
      this.getApi(this.dataCreateMails);
    },
    showModalNewMails() {
      this.getDataCreateMails();
    },
    getNewMailsTask() {
      let body = {};
      let mailsBody = JSON.parse(localStorage.getItem("createNewMailsBody"));
      if (mailsBody) body = mailsBody;
      createNewMailsTask(body)
        .then((res) => {
          if (res.data.status == "finished") {
            this.msgAlert = this.msgSuccsess;
            this.stopGetApi();
            if (res.data.response) {
              if (res.data.response.error) this.msgAlert = this.msgFail;
            }
            this.showModal("modalNewMailsAlert");
            setTimeout(() => {
              this.closeModal("modalNewMailsAlert");
              this.redirectNewMails();
            }, 3000);
          }
        })
        .catch((response) => {
          if (response.response.status != 504) {
            this.stopGetApi();
          }
        });
    },
    getApi(isCreateMails) {
      if (isCreateMails && this.interval == null) {
        if (this.dataCreateMails) this.getNewMailsTask();
        this.interval = setInterval(() => {
          if (this.dataCreateMails) this.getNewMailsTask();
        }, 70000);
      }
    },
    stopGetApi() {
      localStorage.setItem("newMailsStatus", false);
      this.setActionMails(false);
      this.setStatusMails(false);
      clearInterval(this.interval);
      this.interval = null;
    },
    redirectNewMails() {
      if (this.$route.name != "new-mails-main") {
        this.func.navigateBack(this.$router, "new-mails-main");
      }
    },
  },
};
</script>
